import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import ChequeAddForm from "../../components/Cheque/Add/ChequeAddForm";
import { client } from "../../service/ApolloClient/ApolloClient";
import { QUERY_CHEQUE } from "../../service/ApolloClient/ApolloQueries";
import { ErrorToast } from "../../hoc/ToastNotify/ToastNotify";
import { withRouter } from "react-router";
import ChequeListAttachment from "./ChequeListAttachment";
import ChequeRepeatePage from "./ChequeRepeatePage";
import Loading from "../../components/UI/Loading/Loading";

export const CHEQUE_SELECT_EDIT = "CHEQUE_SELECT_EDIT";
export const CHEQUE_SELECT_ATTACHMENT = "CHEQUE_SELECT_ATTACHMENT";
export const CHEQUE_SELECT_REPEAT = "CHEQUE_SELECT_REPEAT";

class ChequeEditPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id,
      data: null,
      loading: true,
      pageSelect: CHEQUE_SELECT_EDIT,
    };

    this.handleSelectPage = this.handleSelectPage.bind(this);
    this.loadPage = this.loadPage.bind(this);
  }

  componentDidMount() {
    this.loadPage();
  }

  componentDidUpdate(prevProps) {
    const id = this.props.match.params.id;
    if (id !== prevProps.match.params.id) {
      this.setState(
        { id, data: null, loading: true, pageSelect: CHEQUE_SELECT_EDIT },
        () => this.loadPage(id),
      );
    }
  }

  handleSelectPage = (page) => {
    this.setState({
      pageSelect: page,
    });
  };

  loadPage = (id = this.state.id) => {
    this.setState({
      loading: true,
    });

    client
      .query({
        query: QUERY_CHEQUE,
        variables: {
          id: parseInt(id),
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        if (String(this.props.match.params.id) !== String(id)) return;
        let data = res.data.cheque;

        this.setState({
          loading: false,
          data: data,
        });
      })
      .catch((err) => {
        if (String(this.props.match.params.id) !== String(id)) return;
        this.setState({
          loading: false,
          data: null,
        });
        ErrorToast("مشکل در دریافت اطلاعات");
      });
  };

  render() {
    const { data, loading, pageSelect } = this.state;

    let componentSelect = <Loading />;

    if (pageSelect === CHEQUE_SELECT_EDIT) {
      componentSelect = (
        <ChequeAddForm
          handleSelectPage={this.handleSelectPage}
          data={data}
          isEdit={true}
        />
      );
    } else if (pageSelect === CHEQUE_SELECT_ATTACHMENT) {
      componentSelect = (
        <ChequeListAttachment
          cheque={data}
          handleBack={() => {
            this.handleSelectPage(CHEQUE_SELECT_EDIT);
          }}
        />
      );
    } else if (pageSelect === CHEQUE_SELECT_REPEAT) {
      componentSelect = <ChequeRepeatePage data={data} />;
    }
    return (
      <Wrapper>
        <BreadcrumbsTemp
          items={[
            {
              title: "ویرایش چک چک ",
              to: "/cheque/add",
            },
          ]}
        />

        <Grid container={true}>
          <Grid item xs={12}>
            {loading ? (
              <Loading />
            ) : data === null ? (
              <Wrapper>اطلاعاتی برای نمایش نیست</Wrapper>
            ) : (
              componentSelect
            )}
          </Grid>
        </Grid>
      </Wrapper>
    );
  }
}

export default withRouter(ChequeEditPage);
